// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1zISw","title":"Images90_title__3aZSu","images":"Images90_images__2js3E"};